import * as React from "react";
import {
  useState,
} from 'react';
import Map from "./Map";
import styled from "styled-components";

const CodeBlock = styled.div`
  padding: 0.5rem;
  border-bottom: 1px solid grey;
  background-color: white;
`;

const Details = styled.div`
  display: grid;
  grid-template-columns: ${props => props.orientation === 'vertical' ? "1fr" : "1fr 1fr 1fr 1fr 1fr 1fr"};
  grid-template-rows: ${props => props.orientation === 'vertical' ? "auto" : "auto"};
  grid-gap: ${props => props.orientation === 'vertical' ? "1.5rem" : "auto"};
  ${props => props.orientation === 'vertical' ? "" : "align-items: center;"};
  ${props => props.orientation === 'vertical' ? "text-align: left" : ""};
`;

const FieldKey = styled.div`
  font-size: 0.8rem;
  text-transform: uppercase;
  padding-top: 0.2rem;
  
`

const EicCodeBlock = (props) => {
  const {
    code,
    orientation,
    withMap
  } = props
  const [showMap, setShowMap] = useState(false);


  const toggleMapView = () => {
    setShowMap((prevShowMap) => !prevShowMap);
  }
  return (
    <CodeBlock key={code.EicCode}>
      <Details orientation={orientation}>
      <div>
        <FieldKey>EIC Code</FieldKey>
        {code.EicCode}
      </div>
      <div>
        <FieldKey>Display Name</FieldKey>
        {code.EicDisplayName}
      </div>
      <div>
        <FieldKey>Long Name</FieldKey>
        {code.EicLongName}
      </div>
      <div>
        <FieldKey>Function List</FieldKey>
        {code.EicTypeFunctionList}
      </div>
      {withMap && <div>
        <button onClick={() => toggleMapView()}>{showMap ? 'Hide' : 'Show'} Map</button>
      </div>}
      </Details>
      <div>
        {withMap && showMap && <Map selectedZone={code.EicCode} />}
      </div>
    </CodeBlock>
  );
};

export default EicCodeBlock;
